module.exports = __webpack_public_path__ + "img/sports-volleyball.6e588b89.svg";